/** Horizontal inset for grid filters/toolbars (matches dashboard page gutter). */
export const GRID_PAGE_GUTTER = 2;

/** Desktop table body: enough rows visible without pushing pagination below the fold. */
export const DESKTOP_TABLE_MIN_HEIGHT = 200;
